import { useEffect } from 'react';
import { useAnalyticsEvents } from '@atlaskit/analytics-next';
import { ANALYTICS_CHANNEL } from '../../../common/constants';
import createEventPayload from './analytics.codegen';
export var ScreenViewedEvent = function ScreenViewedEvent(_ref) {
  var screen = _ref.screen;
  var _useAnalyticsEvents = useAnalyticsEvents(),
    createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
  useEffect(function () {
    createAnalyticsEvent(createEventPayload("screen.".concat(screen, ".viewed"), {})).fire(ANALYTICS_CHANNEL);
  }, [createAnalyticsEvent, screen]);
  return null;
};